import axios from "../../api/axiosConfig";
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";
import { getItem, removeItem, clear } from "../../utils/storageHelper";
import { auth } from "../../firebase/firebaseConfig";

export default async () => {
    console.log("Signing out...");

    if (typeof window !== "undefined") {

        const oidcKey = `oidc.user:${import.meta.env.VITE_PUBLIC_IDP_ROOT}:${import.meta.env.VITE_PUBLIC_IDP_CLIENT}`;

        try {
            const firebaseData = JSON.parse(await getItem(`firebase:user:${import.meta.env.VITE_PUBLIC_APP_ENV}`) || 'null');
            let oidcData = null;
            if (Capacitor.isNativePlatform()) {
                const userObject = await Preferences.get({ key: oidcKey });
                oidcData = userObject.value;
            } else {
                oidcData = await getItem(oidcKey);
            }
            // Clear all storage at the start of sign out
            await clear();
            if (Capacitor.isNativePlatform()) {
                await Preferences.clear();
            } else {
                sessionStorage.clear();
            }

            await removeItem("calendar_access_token");

            if (firebaseData) {
                await removeItem(`firebase:user:${import.meta.env.VITE_PUBLIC_APP_ENV}`);
                await removeItem("license");

                const signOutresponse = await axios.post(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Firebase/signOut`,
                    {},
                    { headers: { "Content-Type": "application/json" } }
                );
                if (signOutresponse.status !== 200) {
                    throw new Error("Sign-out failed");
                }
                if (auth.currentUser) {
                    await auth.signOut();
                }
                // Clean up OIDC data if it exists
                await removeItem(oidcKey);
                
                if (oidcData) {
                    try {
                        const user = JSON.parse(oidcData);
                        const idToken = user.id_token;

                        let redirectUri;

                        if (Capacitor.isNativePlatform()) {
                            redirectUri = import.meta.env.VITE_DEVICE_DOMAIN;
                        } else {
                            redirectUri = import.meta.env.VITE_PUBLIC_DOMAIN;
                        }
                        // Redirect to IDP endsession with OIDC token hint
                        window.location.href = `${import.meta.env.VITE_PUBLIC_IDP_ROOT}/connect/endsession?id_token_hint=${idToken}&post_logout_redirect_uri=${redirectUri}`;
                    } catch (error) {
                        console.error("Error parsing OIDC data during sign-out:", error);
                        // Fall through to local sign-out below
                    }
                }
                
                // If no OIDC data or parsing failed, perform local sign-out only
                // This is normal - OIDC sessionStorage may have expired while Firebase session was still valid
                if (!oidcData) {
                    console.log("No OIDC data found - performing local sign-out");
                    if (Capacitor.isNativePlatform()) {
                        window.location.href = `${import.meta.env.VITE_DEVICE_DOMAIN}Welcome`;
                    } else {
                        window.location.href = `${import.meta.env.VITE_PUBLIC_DOMAIN}Welcome`;
                    }
                }
            } else {
                if (Capacitor.isNativePlatform()) {
                    window.location.href = `${import.meta.env.VITE_DEVICE_DOMAIN}Welcome`;
                }
                else {
                    console.log("No Firebase data. Redirecting to welcome");
                    window.location.href = `${import.meta.env.VITE_PUBLIC_DOMAIN}Welcome`;
                }
               
            }

        } catch (error) {
            console.error("Error signing out:", error);
            await clear();
            if (Capacitor.isNativePlatform()) {
                await Preferences.clear();
                window.location.href = `${import.meta.env.VITE_DEVICE_DOMAIN}Welcome`;
            } else {
                window.location.href = `${import.meta.env.VITE_PUBLIC_DOMAIN}Welcome`;
            }
        }
    }
};
